import { z } from 'zod';

/**
 * Payload for `run.cancel.requested` — a control-plane signal asking the
 * reactor to abort whatever handler is running for `correlation_id`.
 *
 * No regular handler claims this event. The reactor's cancel-listener watches
 * the events table via Realtime, looks up the active AbortController by
 * correlation_id, and calls `.abort(reason)`. The cancel event row itself is
 * marked `status='applied'` (terminal control-plane status) once consumed.
 */
export const runCancelRequestedSchema = z.object({
  correlation_id: z.string().uuid(),
  reason: z.string().optional(),
});

export type RunCancelRequestedPayload = z.infer<typeof runCancelRequestedSchema>;
